export function setCardQuantities(userData){
    const cardId = userData.card_id;
    const cardRow = document.getElementById(cardId);
    if(!cardRow){
        return;
    }
    const intOwnInput = document.getElementById(`${cardId}-collection-count-input`);
    const intTradeInput = document.getElementById(`${cardId}-trade-count-input`);
    const intWantInput = document.getElementById(`${cardId}-wanted-count-input`);
    const boolOwnInput = document.getElementById(`${cardId}-collection-check-input`);
    const boolTradeInput = document.getElementById(`${cardId}-trade-check-input`);
    const boolWantInput = document.getElementById(`${cardId}-wanted-check-input`);

    const owned = Number(userData.owned_count) || 0;
    const trade = Number(userData.trade_count) || 0;
    const wanted = Number(userData.wanted_count) || 0;

    cardRow.dataset.bsOwned = owned;
    cardRow.dataset.bsWanted = wanted;
    cardRow.dataset.bsTrade = trade;
    cardRow.classList.toggle('is-owned', owned > 0);

    if(intOwnInput){
        intOwnInput.value = owned;
    }
    if(intTradeInput){
        intTradeInput.value = trade;
    }
    if(intWantInput){
        intWantInput.value = wanted;
    }
    if(boolOwnInput){
        boolOwnInput.checked = owned > 0;
    }
    if(boolTradeInput){
        boolTradeInput.checked = trade > 0;
    }
    if(boolWantInput){
        boolWantInput.checked = wanted > 0;
    }
}
